// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3E7RY","tab":"Tabs_tab__39Aol","tabActive":"Tabs_tabActive__14M1W"};